import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18Position = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M14 1.375H4A2.625 2.625 0 0 0 1.375 4v10A2.625 2.625 0 0 0 4 16.625h10A2.625 2.625 0 0 0 16.625 14V4A2.625 2.625 0 0 0 14 1.375M4 2.625h10c.76 0 1.375.616 1.375 1.375v10c0 .76-.616 1.375-1.375 1.375H4c-.76 0-1.375-.616-1.375-1.375V4c0-.76.616-1.375 1.375-1.375"
      }), /*#__PURE__*/jsx("path", {
        d: "M10.5 4.375a2.625 2.625 0 0 1 .166 5.245l-.166.005H7.125V13a.624.624 0 0 1-.533.618l-.092.007a.624.624 0 0 1-.618-.533L5.875 13V5c0-.314.231-.574.533-.618l.092-.007zm-3.375 4H10.5a1.375 1.375 0 0 0 .132-2.744l-.132-.006H7.125z"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Position$1 = Svg18Position;

export { Svg18Position$1 as default };
